import React from 'react';
import { ScrollView, View } from 'react-native';
import { CommonStyles } from '../../styles';
import Bar from '../SegmentedControl/Bar';
import PNRInfo from './PNRInfo';
import CoverSlide from './CoverSlide';
import TravelerSafety from './TravelerSafety';
import { useTranslation } from 'react-i18next';
import { i18nNS, useComponentTKey } from '../../i18n';
import { useSelector } from 'react-redux';
import useTripOptions from '../../utils/useTripOptions';
import {
  hasNonSabreHotel,
  selectFirstReceipt,
  selectLastDutyOfCareDateChecked,
  selectReceiptIsCancelable,
  selectReceiptIsChangeable,
} from '../../store/selectors/mytrips.selector';
import LoaderOverlay from '../modals/LoaderOverlay';
import { useNavigation } from '@react-navigation/native';
import { Modals, Screens } from '../../constants/ScreenNames';
import { selectUserProfile } from '../../store/selectors/profile.selector';
import EasyCardUsedDetails from './EasyCardUsedDetails';

const CoverPage = ({ name, pnr, startDate, img, easyCardData }) => {
  const { t } = useTranslation(i18nNS.tripHub);
  const { tKey } = useComponentTKey('TripHubScreen');
  const navigation = useNavigation();
  const receiptResponseIsChangeable = useSelector(selectReceiptIsChangeable);
  const receiptResponseIsCancelable = useSelector(selectReceiptIsCancelable);
  const hasNonSabreHotelBool = useSelector(hasNonSabreHotel);
  const lastDutyOfCareDateChecked = useSelector(selectLastDutyOfCareDateChecked);
  const receiptResponse = useSelector(selectFirstReceipt);
  const companySupportDetails = useSelector(selectUserProfile);
  const [onSelect, options, cancelLoading] = useTripOptions(
    receiptResponseIsChangeable,
    receiptResponseIsCancelable,
    hasNonSabreHotelBool,
    companySupportDetails
  );

  const onPressTravelSafety = () => {
    navigation.navigate(Modals.TravelerSafetyModal, {
      tripKey: receiptResponse.TripId,
    });
    console.log('traveler safety');
  };

  const onPressEasyCard = (item) => {
    navigation.navigate(Screens.EasyCardScreen, { incompleteCardData: item, receiptResponse });
  };

  return (
    <ScrollView style={CommonStyles.pb3}>
      {cancelLoading && <LoaderOverlay loadingText={t(tKey('Cancelling'))} />}
      <CoverSlide name={name} startDate={startDate} img={img} />
      <View style={{ backgroundColor: 'white' }}>
        <Bar style={CommonStyles.py5} items={options} onChange={onSelect} />
        <PNRInfo style={CommonStyles.mb3} label={t(tKey('AgencyRecordLocator'))} value={pnr} />
        <TravelerSafety onPress={onPressTravelSafety} lastDateCheck={lastDutyOfCareDateChecked} />
        {easyCardData?.length > 0 && (
          <EasyCardUsedDetails
            data={easyCardData}
            onPress={(item) => {
              onPressEasyCard(item);
            }}
          />
        )}
      </View>
    </ScrollView>
  );
};

export default CoverPage;
